import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from 'axios';
import { injectable } from "inversify";
import { AppService, Types } from '../../App/Services/AppService';
import CommandResult from "../../Common/Models/CommandResult";
import UpdateSecurityTransferCommand from "../SecurityTransfer/Models/Commands/UpdateSecurityTransferCommand";
import SecurityTransferLookup from "../SecurityTransfer/Models/Lookups/SecurityTransferLookup";
import SecurityTransferSearchCriteria from "../SecurityTransfer/Models/Queries/SecurityTransferSearchCriteria";
import CreateSecurityTransferCommand from "../SecurityTransfer/Models/Commands/CreateSecurityTransferCommand";

export interface ISecurityTransfersApiClient {
    createSecurityTransfer(command: Model.PlainObject<CreateSecurityTransferCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getPagedSecurityTransfers(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<SecurityTransferSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<SecurityTransferLookup>>>;
    updateSecurityTransfer(command: Model.PlainObject<UpdateSecurityTransferCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class SecurityTransfersApiClient extends Data.ApiClientBase implements ISecurityTransfersApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/SecurityTransfer`)
    }

    public createSecurityTransfer(command: Model.PlainObject<CreateSecurityTransferCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/CreateSecurityTransfer`, command);
    }

    public getPagedSecurityTransfers(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<SecurityTransferSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<SecurityTransferLookup>>> {
        return this.axios.get(`${this.apiPath}/GetSecurityTransfers?${Utils.getQueryString(payload)}`);
    }

    public updateSecurityTransfer(command: Model.PlainObject<UpdateSecurityTransferCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateSecurityTransfer`, command);
    }
}